(function(){"use strict";try{if(typeof document<"u"){var t=document.createElement("style");t.appendChild(document.createTextNode('/*! tailwindcss v3.4.3 | MIT License | https://tailwindcss.com*/*,:before,:after{box-sizing:border-box;border-width:0;border-style:solid;border-color:#e5e7eb}:before,:after{--tw-content: ""}html,:host{line-height:1.5;-webkit-text-size-adjust:100%;-moz-tab-size:4;-o-tab-size:4;tab-size:4;font-family:ui-sans-serif,system-ui,sans-serif,"Apple Color Emoji","Segoe UI Emoji",Segoe UI Symbol,"Noto Color Emoji";font-feature-settings:normal;font-variation-settings:normal;-webkit-tap-highlight-color:transparent}body{margin:0;line-height:inherit}hr{height:0;color:inherit;border-top-width:1px}abbr:where([title]){-webkit-text-decoration:underline dotted;text-decoration:underline dotted}h1,h2,h3,h4,h5,h6{font-size:inherit;font-weight:inherit}a{color:inherit;text-decoration:inherit}b,strong{font-weight:bolder}code,kbd,samp,pre{font-family:ui-monospace,SFMono-Regular,Menlo,Monaco,Consolas,Liberation Mono,Courier New,monospace;font-feature-settings:normal;font-variation-settings:normal;font-size:1em}small{font-size:80%}sub,sup{font-size:75%;line-height:0;position:relative;vertical-align:baseline}sub{bottom:-.25em}sup{top:-.5em}table{text-indent:0;border-color:inherit;border-collapse:collapse}button,input,optgroup,select,textarea{font-family:inherit;font-feature-settings:inherit;font-variation-settings:inherit;font-size:100%;font-weight:inherit;line-height:inherit;letter-spacing:inherit;color:inherit;margin:0;padding:0}button,select{text-transform:none}button,input:where([type=button]),input:where([type=reset]),input:where([type=submit]){-webkit-appearance:button;background-color:transparent;background-image:none}:-moz-focusring{outline:auto}:-moz-ui-invalid{box-shadow:none}progress{vertical-align:baseline}::-webkit-inner-spin-button,::-webkit-outer-spin-button{height:auto}[type=search]{-webkit-appearance:textfield;outline-offset:-2px}::-webkit-search-decoration{-webkit-appearance:none}::-webkit-file-upload-button{-webkit-appearance:button;font:inherit}summary{display:list-item}blockquote,dl,dd,h1,h2,h3,h4,h5,h6,hr,figure,p,pre{margin:0}fieldset{margin:0;padding:0}legend{padding:0}ol,ul,menu{list-style:none;margin:0;padding:0}dialog{padding:0}textarea{resize:vertical}input::-moz-placeholder,textarea::-moz-placeholder{opacity:1;color:#9ca3af}input::placeholder,textarea::placeholder{opacity:1;color:#9ca3af}button,[role=button]{cursor:pointer}:disabled{cursor:default}img,svg,video,canvas,audio,iframe,embed,object{display:block;vertical-align:middle}img,video{max-width:100%;height:auto}[hidden]{display:none}*,:before,:after{--tw-border-spacing-x: 0;--tw-border-spacing-y: 0;--tw-translate-x: 0;--tw-translate-y: 0;--tw-rotate: 0;--tw-skew-x: 0;--tw-skew-y: 0;--tw-scale-x: 1;--tw-scale-y: 1;--tw-pan-x: ;--tw-pan-y: ;--tw-pinch-zoom: ;--tw-scroll-snap-strictness: proximity;--tw-gradient-from-position: ;--tw-gradient-via-position: ;--tw-gradient-to-position: ;--tw-ordinal: ;--tw-slashed-zero: ;--tw-numeric-figure: ;--tw-numeric-spacing: ;--tw-numeric-fraction: ;--tw-ring-inset: ;--tw-ring-offset-width: 0px;--tw-ring-offset-color: #fff;--tw-ring-color: rgb(59 130 246 / .5);--tw-ring-offset-shadow: 0 0 #0000;--tw-ring-shadow: 0 0 #0000;--tw-shadow: 0 0 #0000;--tw-shadow-colored: 0 0 #0000;--tw-blur: ;--tw-brightness: ;--tw-contrast: ;--tw-grayscale: ;--tw-hue-rotate: ;--tw-invert: ;--tw-saturate: ;--tw-sepia: ;--tw-drop-shadow: ;--tw-backdrop-blur: ;--tw-backdrop-brightness: ;--tw-backdrop-contrast: ;--tw-backdrop-grayscale: ;--tw-backdrop-hue-rotate: ;--tw-backdrop-invert: ;--tw-backdrop-opacity: ;--tw-backdrop-saturate: ;--tw-backdrop-sepia: ;--tw-contain-size: ;--tw-contain-layout: ;--tw-contain-paint: ;--tw-contain-style: }::backdrop{--tw-border-spacing-x: 0;--tw-border-spacing-y: 0;--tw-translate-x: 0;--tw-translate-y: 0;--tw-rotate: 0;--tw-skew-x: 0;--tw-skew-y: 0;--tw-scale-x: 1;--tw-scale-y: 1;--tw-pan-x: ;--tw-pan-y: ;--tw-pinch-zoom: ;--tw-scroll-snap-strictness: proximity;--tw-gradient-from-position: ;--tw-gradient-via-position: ;--tw-gradient-to-position: ;--tw-ordinal: ;--tw-slashed-zero: ;--tw-numeric-figure: ;--tw-numeric-spacing: ;--tw-numeric-fraction: ;--tw-ring-inset: ;--tw-ring-offset-width: 0px;--tw-ring-offset-color: #fff;--tw-ring-color: rgb(59 130 246 / .5);--tw-ring-offset-shadow: 0 0 #0000;--tw-ring-shadow: 0 0 #0000;--tw-shadow: 0 0 #0000;--tw-shadow-colored: 0 0 #0000;--tw-blur: ;--tw-brightness: ;--tw-contrast: ;--tw-grayscale: ;--tw-hue-rotate: ;--tw-invert: ;--tw-saturate: ;--tw-sepia: ;--tw-drop-shadow: ;--tw-backdrop-blur: ;--tw-backdrop-brightness: ;--tw-backdrop-contrast: ;--tw-backdrop-grayscale: ;--tw-backdrop-hue-rotate: ;--tw-backdrop-invert: ;--tw-backdrop-opacity: ;--tw-backdrop-saturate: ;--tw-backdrop-sepia: ;--tw-contain-size: ;--tw-contain-layout: ;--tw-contain-paint: ;--tw-contain-style: }')),document.head.appendChild(t)}}catch(e){console.error("vite-plugin-css-injected-by-js",e)}})();
var Ti = Object.defineProperty;
var hi = (r, i, o) => i in r ? Ti(r, i, { enumerable: !0, configurable: !0, writable: !0, value: o }) : r[i] = o;
var F = (r, i, o) => (hi(r, typeof i != "symbol" ? i + "" : i, o), o), mn = (r, i, o) => {
  if (!i.has(r))
    throw TypeError("Cannot " + o);
};
var W = (r, i, o) => (mn(r, i, "read from private field"), o ? o.call(r) : i.get(r)), ie = (r, i, o) => {
  if (i.has(r))
    throw TypeError("Cannot add the same private member more than once");
  i instanceof WeakSet ? i.add(r) : i.set(r, o);
}, gn = (r, i, o, c) => (mn(r, i, "write to private field"), c ? c.call(r, o) : i.set(r, o), o);
import { createGlobalStyle as ki, ThemeProvider as Tn, useTheme as Cn } from "styled-components";
import { useState as Ai, useEffect as Le, useRef as bi } from "react";
import { jsxs as yi, jsx as x } from "react/jsx-runtime";
const Ne = {
  primary: "99.9rem",
  secondary: "0.5rem",
  tertiary: "0.25rem",
  ellipse: "99.9rem"
}, Ie = {
  xs: 0,
  sm: "35.875rem",
  // 574px
  md: "47.9375rem",
  // 767px
  lg: "61.9375rem",
  // 991px
  xl: "74.9375rem"
  // 1199px
}, Be = {
  xxtiny: "0.0625rem",
  // 1px / 16 = 0.0625rem
  xtiny: "0.125rem",
  // 2px / 16 = 0.125rem
  tiny: "0.25rem",
  // 4px / 16 = 0.25rem
  xsmall: "0.375rem",
  // 6px / 16 = 0.375rem
  small: "0.5rem",
  // 8px / 16 = 0.5rem
  regular: "0.75rem",
  // 12px / 16 = 0.75rem
  medium: "1rem",
  // 16px / 16 = 1rem
  large: "1.5rem",
  // 24px / 16 = 1.5rem
  xlarge: "2rem",
  // 32px / 16 = 2rem
  xxlarge: "2.5rem",
  // 40px / 16 = 2.5rem
  huge: "3rem"
  // 48px / 16 = 3rem
}, pe = {
  highlight: 0.15,
  disabled: 0.28,
  overlay: 0.4,
  secondary: 0.8
}, Ci = {
  regular: "0 0 0.25rem 0 rgb(0 0 0 / 25%)",
  uber: "0 0 0.625rem 0 rgb(0 0 0 / 35%)",
  stickyRow: "0px 4px 5px 0px rgb(0 0 0 / 35%)",
  stickyFooter: "0px -4px 5px 0px rgb(0 0 0 / 35%)"
}, _i = { focus: "0 0 0.375rem #4ACBCE" }, He = {
  dropShadow: Ci,
  ..._i
}, Ge = {
  bodySmall: {
    fontSize: "0.625rem",
    fontWeight: 400,
    lineHeight: "1rem"
  },
  bodyMedium: {
    fontSize: "0.75rem",
    fontWeight: 400,
    lineHeight: "1.125rem"
  },
  bodyRegular: {
    fontSize: "0.875rem",
    fontWeight: 400,
    lineHeight: "1.25rem"
  },
  headingSmall: {
    fontSize: "0.75rem",
    fontWeight: 600,
    lineHeight: "1.125rem"
  },
  headingMedium: {
    fontSize: "0.875rem",
    fontWeight: 600,
    lineHeight: "1.25rem"
  },
  headingRegular: {
    fontSize: "1rem",
    fontWeight: 600,
    lineHeight: "1.5rem"
  },
  headingLarge: {
    fontSize: "1.125rem",
    fontWeight: 700,
    lineHeight: "1.625rem"
  },
  linkSmall: {
    fontSize: "0.625rem",
    fontWeight: 400,
    lineHeight: "1rem",
    textDecoration: "underline",
    textUnderlineOffset: "0.2rem"
  },
  linkMedium: {
    fontSize: "0.75rem",
    fontWeight: 400,
    lineHeight: "1.125rem",
    textDecoration: "underline",
    textUnderlineOffset: "0.2rem"
  },
  linkRegular: {
    fontSize: "0.875rem",
    fontWeight: 400,
    lineHeight: "1.25rem",
    textDecoration: "underline",
    textUnderlineOffset: "0.2rem"
  }
}, xe = {
  family: "Inter, sans-serif",
  importUrl: "https://fonts.googleapis.com/css2?family=Inter:wght@100;200;300;400;500;600;700;800;900&display=swap"
}, Ri = {
  primary: {
    main: "#37454B",
    weak: "#303C41",
    strong: "#3E4D54",
    ink: "#FFFFFF"
  },
  secondary: {
    main: "#1E2528",
    weak: "#121212",
    strong: "#273135",
    ink: "#FFFFFF"
  },
  tertiary: {
    main: "#121212",
    weak: "#121212",
    strong: "#1E2528",
    ink: "#FFFFFF"
  }
}, Di = {
  primary: {
    main: "#FFFFFF",
    weak: "#EDF2F7",
    strong: "#FFFFFF",
    ink: "#121212"
  },
  inverse: {
    main: "#121212",
    weak: "#121212",
    strong: "#171923",
    ink: "#FFFFFF"
  }
}, Si = {
  primary: {
    main: "#FFFFFF",
    weak: "#E6E7E7",
    strong: "#FFFFFF"
  },
  inverse: {
    main: "#121212",
    weak: "#121212",
    strong: "#171923"
  },
  highlight: {
    main: "#B71E49",
    weak: "#911039",
    strong: "#C43F60"
  }
}, wi = {
  main: "#1370C2",
  weak: "#0D5A9E",
  strong: "#3888CF",
  ink: "#FFFFFF"
}, Oi = {
  main: "#303C41",
  weak: "#273135",
  strong: "#37454B",
  ink: "#FFFFFF"
}, vi = {
  main: "#353F4A",
  strong: "#232A31",
  weak: "#232A31",
  ink: "#E6F2FF"
}, _n = Array(5).fill(Oi, 0).fill(vi, 1, 2), _ = {
  info: {
    main: "#3182CE",
    ink: "#FFFFFF"
  },
  success: {
    main: "#38A169",
    ink: "#FFFFFF"
  },
  warning: {
    main: "#DD6B20",
    ink: "#FFFFFF"
  },
  error: {
    main: "#E53E3E",
    ink: "#FFFFFF"
  },
  unknown: {
    main: "#CBD5E0",
    ink: "#121212"
  }
}, Ei = {
  info: {
    ..._.info,
    weak: "#2B6CB0",
    strong: "#4299E1"
  },
  success: {
    ..._.success,
    weak: "#25855A",
    strong: "#48BB78"
  },
  warning: {
    ..._.warning,
    weak: "#C05621",
    strong: "#ED8936"
  },
  error: {
    ..._.error,
    weak: "#C53030",
    strong: "#F56565"
  },
  unknown: {
    ..._.unknown,
    weak: "#A0AEC0",
    strong: "#E2E8F0"
  }
}, Li = {
  primary: {
    main: "#232A31",
    strong: "#313B45",
    weak: "#313B45",
    ink: "#E6F2FF"
  },
  secondary: { ..._n[1] }
}, Ni = {
  canvas: Ri,
  graphics: Di,
  ink: Si,
  interface: wi,
  layering: _n,
  messaging: Ei,
  navigation: Li
}, Re = {
  primary: {
    main: "#CBD5E0",
    strong: "#A0AEC0",
    weak: "#E2E8F0",
    ink: "#121212"
  },
  secondary: {
    main: "#EDF2F7",
    strong: "#E2E8F0",
    weak: "#FFFFFF",
    ink: "#121212"
  },
  tertiary: {
    main: "#FFFFFF",
    strong: "#EDF2F7",
    weak: "#FFFFFF",
    ink: "#121212"
  }
}, Ii = {
  primary: {
    main: "#121212",
    strong: "#121212",
    weak: "#171923",
    ink: "#FFFFFF"
  },
  inverse: {
    main: "#FFFFFF",
    strong: "#EDF2F7",
    weak: "#FFFFFF",
    ink: "#121212"
  }
}, Bi = {
  primary: {
    main: "#121212",
    strong: "#121212",
    weak: "#171923"
  },
  inverse: {
    main: "#FFFFFF",
    strong: "#EDF2F7",
    weak: "#FFFFFF"
  },
  highlight: {
    main: "#911039",
    strong: "#6B062A",
    weak: "#B71E49"
  }
}, pi = {
  main: "#2B6CB0",
  strong: "#2C5282",
  weak: "#3182CE",
  ink: "#FFFFFF"
}, Hi = {
  main: "#A0AEC0",
  strong: "#718096",
  weak: "#CBD5E0",
  ink: "#121212"
}, Gi = {
  main: "#353F4A",
  strong: "#232A31",
  weak: "#232A31",
  ink: "#E6F2FF"
}, xi = Array(5).fill(Hi, 0).fill(Gi, 1, 2), Ki = {
  info: {
    ..._.info,
    strong: "#2B6CB0",
    weak: "#4299E1"
  },
  success: {
    ..._.success,
    strong: "#25855A",
    weak: "#48BB78"
  },
  warning: {
    ..._.warning,
    strong: "#C05621",
    weak: "#ED8936"
  },
  error: {
    ..._.error,
    strong: "#C53030",
    weak: "#F56565"
  },
  unknown: {
    ..._.unknown,
    strong: "#A0AEC0",
    weak: "#E2E8F0"
  }
}, $i = {
  primary: {
    ...Re.tertiary
  },
  secondary: { ...Re.tertiary }
}, zi = {
  canvas: Re,
  graphics: Ii,
  ink: Bi,
  interface: pi,
  layering: xi,
  messaging: Ki,
  navigation: $i
}, N = {
  ...Ni
}, I = {
  ...zi
}, R = { DARK: "#121212", LIGHT: "#FFFFFF" }, K = { DARK: "#999999", LIGHT: "#999999" }, $ = { DARK: "#333333", LIGHT: "#ECECEC" }, de = { DARK: "#676767", LIGHT: "#CCCCCC" }, Rn = { DARK: "#232323", LIGHT: "#EDF2F7" }, a = { DARK_CONTRAST: "#121212", LIGHT_CONTRAST: "#FFFFFF" }, Dn = {
  pitchLines: { main: "#0EE3F0" },
  primary: {
    main: "#4378FF"
  },
  secondary: {
    main: "#EB3F3F"
  }
}, ji = {
  fieldLines: $.DARK,
  fieldZones: {
    tenYard: R.DARK,
    tenYardAlternate: "#1A1A1A",
    endZone: "#222222"
  },
  positions: {
    /* Defense */
    defaultDefense: { main: "#e84200", ink: a.LIGHT_CONTRAST },
    defensiveLineman: { main: "#fff31d", ink: a.DARK_CONTRAST },
    lineBacker: { main: "#ff9700", ink: a.LIGHT_CONTRAST },
    defensiveBack: { main: "#e84200", ink: a.LIGHT_CONTRAST },
    kickPuntReceiver: { main: "#e84200", ink: a.LIGHT_CONTRAST },
    /* Offense */
    defaultOffense: { main: "#258eff", ink: a.LIGHT_CONTRAST },
    offensiveLine: { main: "#64fff2", ink: a.LIGHT_CONTRAST },
    tightEnd: { main: "#14d3f8", ink: a.LIGHT_CONTRAST },
    wideReceiver: { main: "#258eff", ink: a.LIGHT_CONTRAST },
    runningBack: { main: "#d8a5ff", ink: a.LIGHT_CONTRAST },
    quarterback: { main: "#db00f0", ink: a.LIGHT_CONTRAST },
    kickerPunter: { main: "#f700b6", ink: a.LIGHT_CONTRAST },
    /* Reserve */
    reserve: { main: "#aaa", ink: a.LIGHT_CONTRAST }
  },
  ball: {
    fill: "#6EF5DF",
    // dataObjects.default.n1.main
    stroke: "#fff"
  },
  ballPath: {
    stroke: "#6EF5DF",
    // dataObjects.default.n1.main
    strokeWidth: 1,
    // default for reference
    strokeDashArray: "3 3"
  },
  lineOfScrimmage: {
    stroke: "#cccccc",
    strokeWidth: 2,
    strokeDashArray: "8 2"
  },
  targetLine: {
    stroke: "#cccccc",
    strokeWidth: 2,
    strokeDashArray: "2 3"
  }
}, Pi = {
  background: R.DARK,
  chartLines: {
    axis: K.DARK,
    // used singular "axis" rather than plural "axes"
    guide: $.DARK,
    marking: de.DARK,
    boundingBox: Rn.DARK
  },
  border: K.DARK
}, Mi = {
  /* Valued, aka "Poseidon" ~ standard valued number gradient */
  valued: [
    "#94009f",
    "#8f0da1",
    "#8a1ba3",
    "#8528a5",
    "#8035a7",
    "#7c43a9",
    "#7750ab",
    "#725dad",
    "#6d6aaf",
    "#6878b1",
    "#6385b3",
    "#6691b5",
    "#699db6",
    "#6caab8",
    "#6fb6b9",
    "#73c2bb",
    "#76cebd",
    "#79dabe",
    "#7ce7c0",
    "#7ff3c1",
    "#82ffc3"
  ],
  /* Unvalued, aka "Plasma" ~ for values with no better/worse connotation */
  unvalued: [
    "#0d0887",
    "#280592",
    "#3e049c",
    "#5002a2",
    "#6300a7",
    "#7401a8",
    "#8606a6",
    "#9511a1",
    "#a51f99",
    "#b22b8f",
    "#bf3984",
    "#ca457a",
    "#d5536f",
    "#de5f65",
    "#e76e5b",
    "#ee7b51",
    "#f58b47",
    "#f99a3e",
    "#fdab33",
    "#febb2b",
    "#fcce25"
  ],
  /* For heat-maps only, background -> modified Magma gradient */
  heatmap: [
    R.DARK,
    "#140e36",
    "#241253",
    "#38106c",
    "#4c117a",
    "#601880",
    "#732081",
    "#862781",
    "#992d80",
    "#ad347c",
    "#c03a76",
    "#d3436e",
    "#e44f64",
    "#f2625d",
    "#f9785d",
    "#fc8e64",
    "#fea571",
    "#febb81",
    "#fed194",
    "#fde7a9",
    "#fcfdbf"
  ],
  /* For values distributed about an average (grey), based on red vs blue */
  divergent: [
    "#1e298b",
    "#313b94",
    "#444d9c",
    "#545ca3",
    "#636baa",
    "#737ab1",
    "#8288b7",
    "#9297be",
    "#a1a5c5",
    "#bfc2d2",
    "#dedfe0",
    // neutral grey mid-tone
    "#f2baad",
    "#f7a18e",
    "#f48e7a",
    "#f17b67",
    "#ed5f4e",
    "#e84335",
    "#e53127",
    "#e11f19",
    "#cb1514",
    "#b40b0e"
  ],
  /* divergent neutral, aka "Neptune" ~ mono-color divergent (no value) about a neutral colour */
  divergentNeutral: [
    "#002d82",
    "#022a77",
    "#04286c",
    "#052560",
    "#072255",
    "#09204a",
    "#0b1d3f",
    "#0d1a34",
    "#0e1728",
    "#10151d",
    R.DARK,
    "#1e2527",
    "#2a383c",
    "#374c51",
    "#435f66",
    "#4f727c",
    "#5b8591",
    "#6798a6",
    "#74acbb",
    "#80bfd0",
    "#8cd2e5"
  ],
  /* built explicity for Soccer xG values */
  thermometer: [
    "#2330a0",
    "#2b44a0",
    "#3257a0",
    "#457cb3",
    "#58a1c6",
    "#75b4c1",
    "#91c7bc",
    "#acd5af",
    "#c7e3a2",
    "#dfe78f",
    "#f6ea7c",
    "#f4d96a",
    "#f2c959",
    "#f1b24e",
    "#ef9b44",
    "#ed8738",
    "#ea732b",
    "#e2581a",
    "#d93c09",
    "#d7240a",
    "#d40b0b"
  ]
}, Ui = {
  ghost: "#cccccc",
  neutral: { main: "#787878", ink: a.LIGHT_CONTRAST },
  // mid grey
  inspection: "#6FA0CC",
  inverse: "#ffffff",
  focus: a.LIGHT_CONTRAST,
  selectionBorder: "#cccccc",
  default: {
    n1: { main: "#6EF5DF", ink: a.DARK_CONTRAST },
    // cyan
    n2: { main: "#FF7A30", ink: a.LIGHT_CONTRAST },
    // orange
    n3: { main: "#D3A7FF", ink: a.DARK_CONTRAST },
    // sky blue
    n4: { main: "#D70F9A", ink: a.LIGHT_CONTRAST },
    // magenta
    n5: { main: "#1DB3F3", ink: a.DARK_CONTRAST },
    // mid blue
    n6: { main: "#FFDA7A", ink: a.DARK_CONTRAST },
    // sand
    n7: { main: "#C138DC", ink: a.LIGHT_CONTRAST },
    // light purple
    n8: { main: "#FFB4C1", ink: a.DARK_CONTRAST }
    // peach
  },
  forAgainst: {
    /* AKA Red vs Blue (For = SB Red) */
    for: { main: "#E21017", ink: a.LIGHT_CONTRAST },
    against: { main: "#0044CC", ink: a.LIGHT_CONTRAST },
    forShade: { main: "#b2080e", ink: a.LIGHT_CONTRAST },
    againstShade: { main: "#00297c", ink: a.LIGHT_CONTRAST },
    forBright: { main: "#F0878B", ink: a.LIGHT_CONTRAST },
    againstBright: { main: "#80A1E5", ink: a.LIGHT_CONTRAST }
  },
  successFail: {
    superSuccess: { main: "#00FF00", ink: a.DARK_CONTRAST },
    // bright green
    success: { main: "#94ffe5", ink: a.DARK_CONTRAST },
    // cyan
    success2: { main: "#0ed0ff", ink: a.DARK_CONTRAST },
    // blue
    neutral: { main: "#666666", ink: a.DARK_CONTRAST },
    // grey
    fail2: { main: "#ff87de", ink: a.DARK_CONTRAST },
    // pink
    fail: { main: "#c247ff", ink: a.DARK_CONTRAST },
    // purple
    superFail: { main: "#ff0020", ink: a.DARK_CONTRAST }
    // red
  },
  ranking: {
    gold: { main: "#82ffc3", ink: a.DARK_CONTRAST },
    // best value or most extreme positively
    silver: { main: "#6cc5ab", ink: a.LIGHT_CONTRAST },
    // second best
    bronze: { main: "#427a7c", ink: a.LIGHT_CONTRAST },
    // third best
    antiBronze: { main: "#4a1f83", ink: a.LIGHT_CONTRAST },
    // third worst
    antiSilver: { main: "#822c9f", ink: a.LIGHT_CONTRAST },
    // second worst
    antiGold: { main: "#d173d8", ink: a.LIGHT_CONTRAST }
    // worst values or most extreme negatively
  },
  winLossDraw: {
    // aka Traffic Lights
    win: { main: "#68B62A", ink: a.DARK_CONTRAST },
    // green
    draw: { main: "#F0CB09", ink: a.DARK_CONTRAST },
    // amber
    loss: { main: "#DF3B3B", ink: a.DARK_CONTRAST }
    // red
  }
}, Wi = {
  pitchLines: de.DARK,
  gridCells: {
    primary: R.DARK,
    secondary: "#1A1A1A",
    tertiary: "#222222",
    stroke: "#333333"
    // not explicitly guide color, though same value in dark mode
  },
  positions: {
    forward: { main: "#6EF5DF", ink: a.DARK_CONTRAST },
    attackingMidfield: { main: "#FF7A30", ink: a.LIGHT_CONTRAST },
    widePlayer: { main: "#D3A7FF", ink: a.LIGHT_CONTRAST },
    centreMidfield: { main: "#D70F9A", ink: a.LIGHT_CONTRAST },
    defensiveMidfield: { main: "#1DB3F3", ink: a.LIGHT_CONTRAST },
    centreBack: { main: "#FFDA7A", ink: a.DARK_CONTRAST },
    fullback: { main: "#C138DC", ink: a.LIGHT_CONTRAST },
    goalkeeper: { main: "#FFB4C1", ink: a.DARK_CONTRAST }
  }
}, qi = {
  visualisation: {
    axis: K.DARK,
    guide: $.DARK,
    label: "#f0f0f0",
    shout: a.LIGHT_CONTRAST
    // super rare ~ LOOK AT ME
  },
  export: {
    header: "#f9f9f9",
    // top of vis
    subHeader: "#f4f4f4",
    // secondary information
    info: "#f0f0f0"
    // general info block text (keys + legends)
  },
  legend: {
    primary: "#f0f0f0",
    secondary: "#f0f0f0"
    // same
  },
  overlay: {
    up: "#f9f9f9",
    down: "#121212"
  }
}, Vi = {
  visualisations: {
    base: Pi,
    dataObjects: Ui,
    dataGradients: Mi,
    text: qi,
    americanFootball: ji,
    soccer: Wi,
    /** deprecated - these are to support backwards compatible colours used in tracking collection frontend  */
    tracking: Dn
  }
}, Qi = {
  fieldLines: $.LIGHT,
  fieldZones: {
    tenYard: R.LIGHT,
    tenYardAlternate: "#F9F9F9",
    endZone: "#F4F4F4"
  },
  positions: {
    /* Defense */
    defaultDefense: { main: "#D15100", ink: a.LIGHT_CONTRAST },
    defensiveLineman: { main: "#EBDE0C", ink: a.DARK_CONTRAST },
    lineBacker: { main: "#EC8102", ink: a.LIGHT_CONTRAST },
    defensiveBack: { main: "#D15100", ink: a.LIGHT_CONTRAST },
    kickPuntReceiver: { main: "#D15100", ink: a.LIGHT_CONTRAST },
    /* Offense */
    defaultOffense: { main: "#0665CA", ink: a.LIGHT_CONTRAST },
    offensiveLine: { main: "#5AE3D7", ink: a.LIGHT_CONTRAST },
    tightEnd: { main: "#04BADE", ink: a.LIGHT_CONTRAST },
    wideReceiver: { main: "#0665CA", ink: a.LIGHT_CONTRAST },
    runningBack: { main: "#B362FB", ink: a.LIGHT_CONTRAST },
    quarterback: { main: "#A200B2", ink: a.LIGHT_CONTRAST },
    kickerPunter: { main: "#B90068", ink: a.LIGHT_CONTRAST },
    /* Reserve */
    reserve: { main: "#AAAAAA", ink: a.LIGHT_CONTRAST }
  },
  ball: {
    fill: "#02C3C8",
    // dataObjects.default.n1.main
    stroke: "#121212"
  },
  ballPath: {
    stroke: "#02C3C8",
    // dataObjects.default.n1.main
    strokeWidth: 1,
    // default for reference
    strokeDashArray: "3 3"
  },
  lineOfScrimmage: {
    stroke: "#777777",
    strokeWidth: 2,
    strokeDashArray: "8 2"
  },
  targetLine: {
    stroke: "#777777",
    strokeWidth: 2,
    strokeDashArray: "2 3"
  }
}, Yi = {
  background: R.LIGHT,
  chartLines: {
    axis: K.LIGHT,
    // used singular "axis" rather than plural "axes"
    guide: $.LIGHT,
    marking: de.LIGHT,
    boundingBox: Rn.LIGHT
  },
  border: K.LIGHT
}, Zi = {
  /* Valued, aka "Poseidon" ~ standard valued number gradient */
  valued: [
    "#5f0065",
    "#5f0d6d",
    "#601a74",
    "#60277c",
    "#613484",
    "#61428c",
    "#614f93",
    "#625c9b",
    "#6269a3",
    "#6376aa",
    "#6383b2",
    "#658eb3",
    "#679ab3",
    "#68a5b4",
    "#6ab1b4",
    "#6cbcb5",
    "#6ec7b5",
    "#70d3b6",
    "#71deb6",
    "#73eab7",
    "#75f5b7"
  ],
  /* Unvalued, aka "Plasma" ~ for values with no better/worse connotation */
  unvalued: [
    "#0d0887",
    "#280592",
    "#3e049c",
    "#5002a2",
    "#6300a7",
    "#7401a8",
    "#8606a6",
    "#9511a1",
    "#a51f99",
    "#b22b8f",
    "#bf3984",
    "#ca457a",
    "#d5536f",
    "#de5f65",
    "#e76e5b",
    "#ee7b51",
    "#f58b47",
    "#f99a3e",
    "#fdab33",
    "#febb2b",
    "#fcce25"
  ],
  /* For heat-maps only, background -> modified Magma gradient */
  heatmap: [
    R.LIGHT,
    "#fefeea",
    "#fdfed4",
    "#fcfdbf",
    "#fde7a9",
    "#fed194",
    "#febb81",
    "#fea571",
    "#fc8e64",
    "#f9785d",
    "#f2625d",
    "#e55064",
    "#d5446d",
    "#c23b75",
    "#ae347b",
    "#9b2e7f",
    "#882781",
    "#752181",
    "#621980",
    "#4f127b",
    "#3b0f70"
  ],
  /* For values distributed about an average (grey), based on red vs blue */
  divergent: [
    "#171832",
    "#252949",
    "#323a60",
    "#3c4770",
    "#45537f",
    "#5b6b91",
    "#7183a3",
    "#93a4bc",
    "#b5c6d5",
    "#d3dee4",
    "#dedfe0",
    // grey mid-tone
    "#f2baad",
    "#f7a18e",
    "#f48e7a",
    "#f17b67",
    "#ed5f4e",
    "#e84335",
    "#e53127",
    "#e11f19",
    "#cb1514",
    "#b40b0e"
  ],
  /* divergent neutral, aka "Neptune" ~ mono-color divergent (no value) about a neutral colour */
  divergentNeutral: [
    "#002d82",
    "#1a428f",
    "#33579b",
    "#4d6ca8",
    "#6681b4",
    "#8096c1",
    "#99abcd",
    "#b3c0da",
    "#ccd5e6",
    "#e6eaf3",
    R.LIGHT,
    "#f4fbfc",
    "#e8f6fa",
    "#ddf2f7",
    "#d1edf5",
    "#c6e9f2",
    "#bae4ef",
    "#afe0ed",
    "#a3dbea",
    "#98d7e8",
    "#8cd2e5"
  ],
  /* built explicity for Soccer xG values */
  thermometer: [
    "#1b2473",
    "#263e85",
    "#305796",
    "#3979af",
    "#419bc8",
    "#59b3c0",
    "#71cbb7",
    "#95d99d",
    "#b9e682",
    "#d6e975",
    "#f2eb68",
    "#f3da56",
    "#f4c944",
    "#ecaf44",
    "#e39544",
    "#e37732",
    "#e2591f",
    "#df4316",
    "#dc2d0c",
    "#be1706",
    "#9f0000"
  ]
}, Xi = {
  ghost: "#cccccc",
  neutral: { main: "#C7C7C7", ink: a.DARK_CONTRAST },
  // mid grey
  inspection: "#6891BD",
  inverse: "#000000",
  focus: a.DARK_CONTRAST,
  selectionBorder: "#666666",
  default: {
    n1: { main: "#02C3C8", ink: a.DARK_CONTRAST },
    // cyan
    n2: { main: "#F14E00", ink: a.LIGHT_CONTRAST },
    // orange
    n3: { main: "#6F04DA", ink: a.LIGHT_CONTRAST },
    // purple
    n4: { main: "#F980DB", ink: a.DARK_CONTRAST },
    // pink
    n5: { main: "#1682BE", ink: a.LIGHT_CONTRAST },
    // sea blue
    n6: { main: "#FFB84D", ink: a.DARK_CONTRAST },
    // sand
    n7: { main: "#740C5A", ink: a.LIGHT_CONTRAST },
    // magenta
    n8: { main: "#BC1090", ink: a.LIGHT_CONTRAST }
    // fuchsia
  },
  forAgainst: {
    /* AKA Red vs Blue (For = SB Red) */
    for: { main: "#E21017", ink: a.LIGHT_CONTRAST },
    against: { main: "#0044CC", ink: a.LIGHT_CONTRAST },
    forShade: { main: "#b2080e", ink: a.LIGHT_CONTRAST },
    againstShade: { main: "#00297c", ink: a.LIGHT_CONTRAST },
    forBright: { main: "#F0878B", ink: a.LIGHT_CONTRAST },
    againstBright: { main: "#80A1E5", ink: a.LIGHT_CONTRAST }
  },
  successFail: {
    superSuccess: { main: "#00A122", ink: a.DARK_CONTRAST },
    // green
    success: { main: "#4CDAB5", ink: a.DARK_CONTRAST },
    // cyan
    success2: { main: "#00BCFA", ink: a.DARK_CONTRAST },
    // blue
    neutral: { main: "#CCCCCC", ink: a.DARK_CONTRAST },
    // grey
    fail2: { main: "#EA7CCD", ink: a.DARK_CONTRAST },
    // pink
    fail: { main: "#8700CE", ink: a.DARK_CONTRAST },
    // purple
    superFail: { main: "#ff0020", ink: a.DARK_CONTRAST }
    // red
  },
  ranking: {
    gold: { main: "#71EDB1", ink: a.DARK_CONTRAST },
    // best value or most extreme positively
    silver: { main: "#73C9BA", ink: a.LIGHT_CONTRAST },
    // second best
    bronze: { main: "#AFEBE1", ink: a.LIGHT_CONTRAST },
    // third best
    antiBronze: { main: "#BAA6D5", ink: a.LIGHT_CONTRAST },
    // third worst
    antiSilver: { main: "#9144AB", ink: a.LIGHT_CONTRAST },
    // second worst
    antiGold: { main: "#700078", ink: a.LIGHT_CONTRAST }
    // worst values or most extreme negatively
  },
  winLossDraw: {
    // aka Traffic Lights
    win: { main: "#719823", ink: a.DARK_CONTRAST },
    // green
    draw: { main: "#DDB903", ink: a.DARK_CONTRAST },
    // amber
    loss: { main: "#DF3B3B", ink: a.DARK_CONTRAST }
    // red
  }
}, Ji = {
  pitchLines: de.LIGHT,
  gridCells: {
    primary: R.LIGHT,
    secondary: "#F9F9F9",
    tertiary: "#F0F0F0",
    stroke: "#ECECEC"
  },
  positions: {
    forward: { main: "#02C3C8", ink: a.DARK_CONTRAST },
    attackingMidfield: { main: "#F14E00", ink: a.LIGHT_CONTRAST },
    widePlayer: { main: "#6F04DA", ink: a.LIGHT_CONTRAST },
    centreMidfield: { main: "#BC1090", ink: a.LIGHT_CONTRAST },
    defensiveMidfield: { main: "#1682BE", ink: a.LIGHT_CONTRAST },
    centreBack: { main: "#FFB84D", ink: a.DARK_CONTRAST },
    fullback: { main: "#740C5A", ink: a.LIGHT_CONTRAST },
    goalkeeper: { main: "#F980DB", ink: a.DARK_CONTRAST }
  }
}, ea = {
  visualisation: {
    axis: K.LIGHT,
    guide: $.LIGHT,
    label: "#404040",
    shout: a.DARK_CONTRAST
    // super rare ~ LOOK AT ME
  },
  export: {
    header: "#333333",
    // top of vis
    subHeader: "#393939",
    // secondary information
    info: "#404040"
    // general info block text (keys + legends)
  },
  legend: {
    primary: "#404040",
    secondary: "#404040"
    // same
  },
  overlay: {
    up: "#f9f9f9",
    down: "#121212"
  }
}, na = {
  visualisations: {
    /*
    Base options cover the background (comes via theme), and other basic blocks /
    */
    base: Yi,
    /*
     These describe how elements drawn in visualisations should get coloured: categorical definitions
    */
    dataObjects: Xi,
    /*
     These describe how elements drawn in visualisations should get coloured: continual definitions
     These are specified as arrays with the first value corresponding to 0 and last value 1 in terms of the
     gradient proportions.
     The number of values specified depends on the scale; the colours as defined here are evenly distributed
         (any scales used non-linearly expect those translations to be governed by scale usage)
     
     The easiest way to convert the array to an output is by using it as the range of a d3.scaleLinear() function
    */
    dataGradients: Zi,
    /*
        Text values can occur in the visualisation - either as background or foreground elements,
            axis labels, data labels etc.
    
        Keys / Legends have a more straightforward set of values
        */
    text: ea,
    /*
    Sport specific sets of information are generally about rendering their pitch/field/court
        Note there is some minor design settings embedded in this that aren't strictly "palette"
    */
    americanFootball: Qi,
    soccer: Ji,
    /** deprecated - these are to support backwards compatible colours used in tracking collection frontend  */
    tracking: Dn
  }
}, B = {
  ...Vi
}, p = {
  ...na
}, ta = {
  main: "#542a66",
  strong: "#492559",
  weak: "#5e3073",
  ink: "#ffffff"
}, ia = {
  main: "#156F73",
  strong: "#136064",
  weak: "#187C81",
  ink: "#ffffff"
}, aa = {
  main: "#B64C00",
  strong: "#9E4200",
  weak: "#CC5500",
  ink: "#ffffff"
}, ra = {
  main: "#F03737",
  strong: "#BD0410",
  weak: "#F03737",
  ink: "#ffffff"
}, oa = {
  main: "#FF6200",
  strong: "#FF6200",
  weak: "#FF7119",
  ink: "#ffffff"
}, re = { brand: { ...ra } }, oe = { brand: { ...ta } }, se = { brand: { ...ia } }, fe = { brand: { ...aa } }, De = { brand: { ...oa } }, sa = {
  borderRadius: Ne,
  breakpoints: Ie,
  visualisationsDark: B,
  visualisationsLight: p,
  foundationsDark: N,
  foundationsLight: I,
  font: xe,
  sizing: Be,
  opacity: pe,
  effects: He,
  typography: Ge,
  iqBrand: oe,
  hudlBrand: De,
  videoBrand: se,
  coreBrand: re,
  trackingBrand: fe
};
function fa({ tokens: r, findKey: i }) {
  const o = i.split(".");
  function c(f, C) {
    const k = C.shift();
    if (f && Object.prototype.hasOwnProperty.call(f, k) && k !== void 0)
      return C.length === 0 ? f[k] : c(f[k], C);
  }
  return c(r, o);
}
const Ke = ({ tokens: r, prefix: i = "" }) => {
  let o = "", c = i || "";
  return !c.endsWith("-") && c !== "" && (c += "-"), Object.keys(r).forEach((f) => {
    typeof r[f] == "object" ? o += Ke({
      prefix: `${c}${f}-`,
      tokens: r[f]
    }) : o += `--${c}${f}: ${r[f]};
`;
  }), o;
}, ca = "sb", la = () => Ke({ tokens: sa, prefix: ca });
var ae = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function da(r) {
  return r && r.__esModule && Object.prototype.hasOwnProperty.call(r, "default") ? r.default : r;
}
var ce = { exports: {} };
ce.exports;
(function(r, i) {
  var o = 200, c = "__lodash_hash_undefined__", f = 800, C = 16, k = 9007199254740991, A = "[object Arguments]", wn = "[object Array]", On = "[object AsyncFunction]", vn = "[object Boolean]", En = "[object Date]", Ln = "[object Error]", je = "[object Function]", Nn = "[object GeneratorFunction]", In = "[object Map]", Bn = "[object Number]", pn = "[object Null]", Pe = "[object Object]", Hn = "[object Proxy]", Gn = "[object RegExp]", xn = "[object Set]", Kn = "[object String]", $n = "[object Undefined]", zn = "[object WeakMap]", jn = "[object ArrayBuffer]", Pn = "[object DataView]", Mn = "[object Float32Array]", Un = "[object Float64Array]", Wn = "[object Int8Array]", qn = "[object Int16Array]", Vn = "[object Int32Array]", Qn = "[object Uint8Array]", Yn = "[object Uint8ClampedArray]", Zn = "[object Uint16Array]", Xn = "[object Uint32Array]", Jn = /[\\^$.*+?()[\]{}|]/g, et = /^\[object .+?Constructor\]$/, nt = /^(?:0|[1-9]\d*)$/, m = {};
  m[Mn] = m[Un] = m[Wn] = m[qn] = m[Vn] = m[Qn] = m[Yn] = m[Zn] = m[Xn] = !0, m[A] = m[wn] = m[jn] = m[vn] = m[Pn] = m[En] = m[Ln] = m[je] = m[In] = m[Bn] = m[Pe] = m[Gn] = m[xn] = m[Kn] = m[zn] = !1;
  var Me = typeof ae == "object" && ae && ae.Object === Object && ae, tt = typeof self == "object" && self && self.Object === Object && self, z = Me || tt || Function("return this")(), Ue = i && !i.nodeType && i, j = Ue && !0 && r && !r.nodeType && r, We = j && j.exports === Ue, ue = We && Me.process, qe = function() {
    try {
      var e = j && j.require && j.require("util").types;
      return e || ue && ue.binding && ue.binding("util");
    } catch {
    }
  }(), Ve = qe && qe.isTypedArray;
  function it(e, n, t) {
    switch (t.length) {
      case 0:
        return e.call(n);
      case 1:
        return e.call(n, t[0]);
      case 2:
        return e.call(n, t[0], t[1]);
      case 3:
        return e.call(n, t[0], t[1], t[2]);
    }
    return e.apply(n, t);
  }
  function at(e, n) {
    for (var t = -1, s = Array(e); ++t < e; )
      s[t] = n(t);
    return s;
  }
  function rt(e) {
    return function(n) {
      return e(n);
    };
  }
  function ot(e, n) {
    return e == null ? void 0 : e[n];
  }
  function st(e, n) {
    return function(t) {
      return e(n(t));
    };
  }
  var ft = Array.prototype, ct = Function.prototype, Q = Object.prototype, Fe = z["__core-js_shared__"], Y = ct.toString, S = Q.hasOwnProperty, Qe = function() {
    var e = /[^.]+$/.exec(Fe && Fe.keys && Fe.keys.IE_PROTO || "");
    return e ? "Symbol(src)_1." + e : "";
  }(), Ye = Q.toString, lt = Y.call(Object), dt = RegExp(
    "^" + Y.call(S).replace(Jn, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
  ), Z = We ? z.Buffer : void 0, Ze = z.Symbol, Xe = z.Uint8Array;
  Z && Z.allocUnsafe;
  var Je = st(Object.getPrototypeOf, Object), en = Object.create, ut = Q.propertyIsEnumerable, Ft = ft.splice, O = Ze ? Ze.toStringTag : void 0, X = function() {
    try {
      var e = Te(Object, "defineProperty");
      return e({}, "", {}), e;
    } catch {
    }
  }(), mt = Z ? Z.isBuffer : void 0, nn = Math.max, gt = Date.now, tn = Te(z, "Map"), P = Te(Object, "create"), Tt = /* @__PURE__ */ function() {
    function e() {
    }
    return function(n) {
      if (!E(n))
        return {};
      if (en)
        return en(n);
      e.prototype = n;
      var t = new e();
      return e.prototype = void 0, t;
    };
  }();
  function v(e) {
    var n = -1, t = e == null ? 0 : e.length;
    for (this.clear(); ++n < t; ) {
      var s = e[n];
      this.set(s[0], s[1]);
    }
  }
  function ht() {
    this.__data__ = P ? P(null) : {}, this.size = 0;
  }
  function kt(e) {
    var n = this.has(e) && delete this.__data__[e];
    return this.size -= n ? 1 : 0, n;
  }
  function At(e) {
    var n = this.__data__;
    if (P) {
      var t = n[e];
      return t === c ? void 0 : t;
    }
    return S.call(n, e) ? n[e] : void 0;
  }
  function bt(e) {
    var n = this.__data__;
    return P ? n[e] !== void 0 : S.call(n, e);
  }
  function yt(e, n) {
    var t = this.__data__;
    return this.size += this.has(e) ? 0 : 1, t[e] = P && n === void 0 ? c : n, this;
  }
  v.prototype.clear = ht, v.prototype.delete = kt, v.prototype.get = At, v.prototype.has = bt, v.prototype.set = yt;
  function D(e) {
    var n = -1, t = e == null ? 0 : e.length;
    for (this.clear(); ++n < t; ) {
      var s = e[n];
      this.set(s[0], s[1]);
    }
  }
  function Ct() {
    this.__data__ = [], this.size = 0;
  }
  function _t(e) {
    var n = this.__data__, t = J(n, e);
    if (t < 0)
      return !1;
    var s = n.length - 1;
    return t == s ? n.pop() : Ft.call(n, t, 1), --this.size, !0;
  }
  function Rt(e) {
    var n = this.__data__, t = J(n, e);
    return t < 0 ? void 0 : n[t][1];
  }
  function Dt(e) {
    return J(this.__data__, e) > -1;
  }
  function St(e, n) {
    var t = this.__data__, s = J(t, e);
    return s < 0 ? (++this.size, t.push([e, n])) : t[s][1] = n, this;
  }
  D.prototype.clear = Ct, D.prototype.delete = _t, D.prototype.get = Rt, D.prototype.has = Dt, D.prototype.set = St;
  function H(e) {
    var n = -1, t = e == null ? 0 : e.length;
    for (this.clear(); ++n < t; ) {
      var s = e[n];
      this.set(s[0], s[1]);
    }
  }
  function wt() {
    this.size = 0, this.__data__ = {
      hash: new v(),
      map: new (tn || D)(),
      string: new v()
    };
  }
  function Ot(e) {
    var n = ne(this, e).delete(e);
    return this.size -= n ? 1 : 0, n;
  }
  function vt(e) {
    return ne(this, e).get(e);
  }
  function Et(e) {
    return ne(this, e).has(e);
  }
  function Lt(e, n) {
    var t = ne(this, e), s = t.size;
    return t.set(e, n), this.size += t.size == s ? 0 : 1, this;
  }
  H.prototype.clear = wt, H.prototype.delete = Ot, H.prototype.get = vt, H.prototype.has = Et, H.prototype.set = Lt;
  function G(e) {
    var n = this.__data__ = new D(e);
    this.size = n.size;
  }
  function Nt() {
    this.__data__ = new D(), this.size = 0;
  }
  function It(e) {
    var n = this.__data__, t = n.delete(e);
    return this.size = n.size, t;
  }
  function Bt(e) {
    return this.__data__.get(e);
  }
  function pt(e) {
    return this.__data__.has(e);
  }
  function Ht(e, n) {
    var t = this.__data__;
    if (t instanceof D) {
      var s = t.__data__;
      if (!tn || s.length < o - 1)
        return s.push([e, n]), this.size = ++t.size, this;
      t = this.__data__ = new H(s);
    }
    return t.set(e, n), this.size = t.size, this;
  }
  G.prototype.clear = Nt, G.prototype.delete = It, G.prototype.get = Bt, G.prototype.has = pt, G.prototype.set = Ht;
  function Gt(e, n) {
    var t = Ae(e), s = !t && ke(e), l = !t && !s && fn(e), u = !t && !s && !l && ln(e), g = t || s || l || u, d = g ? at(e.length, String) : [], T = d.length;
    for (var b in e)
      g && // Safari 9 has enumerable `arguments.length` in strict mode.
      (b == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
      l && (b == "offset" || b == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
      u && (b == "buffer" || b == "byteLength" || b == "byteOffset") || // Skip index properties.
      on(b, T)) || d.push(b);
    return d;
  }
  function me(e, n, t) {
    (t !== void 0 && !te(e[n], t) || t === void 0 && !(n in e)) && ge(e, n, t);
  }
  function xt(e, n, t) {
    var s = e[n];
    (!(S.call(e, n) && te(s, t)) || t === void 0 && !(n in e)) && ge(e, n, t);
  }
  function J(e, n) {
    for (var t = e.length; t--; )
      if (te(e[t][0], n))
        return t;
    return -1;
  }
  function ge(e, n, t) {
    n == "__proto__" && X ? X(e, n, {
      configurable: !0,
      enumerable: !0,
      value: t,
      writable: !0
    }) : e[n] = t;
  }
  var Kt = Xt();
  function ee(e) {
    return e == null ? e === void 0 ? $n : pn : O && O in Object(e) ? Jt(e) : ri(e);
  }
  function an(e) {
    return M(e) && ee(e) == A;
  }
  function $t(e) {
    if (!E(e) || ii(e))
      return !1;
    var n = ye(e) ? dt : et;
    return n.test(ci(e));
  }
  function zt(e) {
    return M(e) && cn(e.length) && !!m[ee(e)];
  }
  function jt(e) {
    if (!E(e))
      return ai(e);
    var n = sn(e), t = [];
    for (var s in e)
      s == "constructor" && (n || !S.call(e, s)) || t.push(s);
    return t;
  }
  function rn(e, n, t, s, l) {
    e !== n && Kt(n, function(u, g) {
      if (l || (l = new G()), E(u))
        Pt(e, n, g, t, rn, s, l);
      else {
        var d = s ? s(he(e, g), u, g + "", e, n, l) : void 0;
        d === void 0 && (d = u), me(e, g, d);
      }
    }, dn);
  }
  function Pt(e, n, t, s, l, u, g) {
    var d = he(e, t), T = he(n, t), b = g.get(T);
    if (b) {
      me(e, t, b);
      return;
    }
    var h = u ? u(d, T, t + "", e, n, g) : void 0, U = h === void 0;
    if (U) {
      var Ce = Ae(T), _e = !Ce && fn(T), Fn = !Ce && !_e && ln(T);
      h = T, Ce || _e || Fn ? Ae(d) ? h = d : li(d) ? h = Qt(d) : _e ? (U = !1, h = Wt(T)) : Fn ? (U = !1, h = Vt(T)) : h = [] : di(T) || ke(T) ? (h = d, ke(d) ? h = ui(d) : (!E(d) || ye(d)) && (h = ei(T))) : U = !1;
    }
    U && (g.set(T, h), l(h, T, s, u, g), g.delete(T)), me(e, t, h);
  }
  function Mt(e, n) {
    return si(oi(e, n, un), e + "");
  }
  var Ut = X ? function(e, n) {
    return X(e, "toString", {
      configurable: !0,
      enumerable: !1,
      value: mi(n),
      writable: !0
    });
  } : un;
  function Wt(e, n) {
    return e.slice();
  }
  function qt(e) {
    var n = new e.constructor(e.byteLength);
    return new Xe(n).set(new Xe(e)), n;
  }
  function Vt(e, n) {
    var t = qt(e.buffer);
    return new e.constructor(t, e.byteOffset, e.length);
  }
  function Qt(e, n) {
    var t = -1, s = e.length;
    for (n || (n = Array(s)); ++t < s; )
      n[t] = e[t];
    return n;
  }
  function Yt(e, n, t, s) {
    var l = !t;
    t || (t = {});
    for (var u = -1, g = n.length; ++u < g; ) {
      var d = n[u], T = void 0;
      T === void 0 && (T = e[d]), l ? ge(t, d, T) : xt(t, d, T);
    }
    return t;
  }
  function Zt(e) {
    return Mt(function(n, t) {
      var s = -1, l = t.length, u = l > 1 ? t[l - 1] : void 0, g = l > 2 ? t[2] : void 0;
      for (u = e.length > 3 && typeof u == "function" ? (l--, u) : void 0, g && ni(t[0], t[1], g) && (u = l < 3 ? void 0 : u, l = 1), n = Object(n); ++s < l; ) {
        var d = t[s];
        d && e(n, d, s, u);
      }
      return n;
    });
  }
  function Xt(e) {
    return function(n, t, s) {
      for (var l = -1, u = Object(n), g = s(n), d = g.length; d--; ) {
        var T = g[++l];
        if (t(u[T], T, u) === !1)
          break;
      }
      return n;
    };
  }
  function ne(e, n) {
    var t = e.__data__;
    return ti(n) ? t[typeof n == "string" ? "string" : "hash"] : t.map;
  }
  function Te(e, n) {
    var t = ot(e, n);
    return $t(t) ? t : void 0;
  }
  function Jt(e) {
    var n = S.call(e, O), t = e[O];
    try {
      e[O] = void 0;
      var s = !0;
    } catch {
    }
    var l = Ye.call(e);
    return s && (n ? e[O] = t : delete e[O]), l;
  }
  function ei(e) {
    return typeof e.constructor == "function" && !sn(e) ? Tt(Je(e)) : {};
  }
  function on(e, n) {
    var t = typeof e;
    return n = n ?? k, !!n && (t == "number" || t != "symbol" && nt.test(e)) && e > -1 && e % 1 == 0 && e < n;
  }
  function ni(e, n, t) {
    if (!E(t))
      return !1;
    var s = typeof n;
    return (s == "number" ? be(t) && on(n, t.length) : s == "string" && n in t) ? te(t[n], e) : !1;
  }
  function ti(e) {
    var n = typeof e;
    return n == "string" || n == "number" || n == "symbol" || n == "boolean" ? e !== "__proto__" : e === null;
  }
  function ii(e) {
    return !!Qe && Qe in e;
  }
  function sn(e) {
    var n = e && e.constructor, t = typeof n == "function" && n.prototype || Q;
    return e === t;
  }
  function ai(e) {
    var n = [];
    if (e != null)
      for (var t in Object(e))
        n.push(t);
    return n;
  }
  function ri(e) {
    return Ye.call(e);
  }
  function oi(e, n, t) {
    return n = nn(n === void 0 ? e.length - 1 : n, 0), function() {
      for (var s = arguments, l = -1, u = nn(s.length - n, 0), g = Array(u); ++l < u; )
        g[l] = s[n + l];
      l = -1;
      for (var d = Array(n + 1); ++l < n; )
        d[l] = s[l];
      return d[n] = t(g), it(e, this, d);
    };
  }
  function he(e, n) {
    if (!(n === "constructor" && typeof e[n] == "function") && n != "__proto__")
      return e[n];
  }
  var si = fi(Ut);
  function fi(e) {
    var n = 0, t = 0;
    return function() {
      var s = gt(), l = C - (s - t);
      if (t = s, l > 0) {
        if (++n >= f)
          return arguments[0];
      } else
        n = 0;
      return e.apply(void 0, arguments);
    };
  }
  function ci(e) {
    if (e != null) {
      try {
        return Y.call(e);
      } catch {
      }
      try {
        return e + "";
      } catch {
      }
    }
    return "";
  }
  function te(e, n) {
    return e === n || e !== e && n !== n;
  }
  var ke = an(/* @__PURE__ */ function() {
    return arguments;
  }()) ? an : function(e) {
    return M(e) && S.call(e, "callee") && !ut.call(e, "callee");
  }, Ae = Array.isArray;
  function be(e) {
    return e != null && cn(e.length) && !ye(e);
  }
  function li(e) {
    return M(e) && be(e);
  }
  var fn = mt || gi;
  function ye(e) {
    if (!E(e))
      return !1;
    var n = ee(e);
    return n == je || n == Nn || n == On || n == Hn;
  }
  function cn(e) {
    return typeof e == "number" && e > -1 && e % 1 == 0 && e <= k;
  }
  function E(e) {
    var n = typeof e;
    return e != null && (n == "object" || n == "function");
  }
  function M(e) {
    return e != null && typeof e == "object";
  }
  function di(e) {
    if (!M(e) || ee(e) != Pe)
      return !1;
    var n = Je(e);
    if (n === null)
      return !0;
    var t = S.call(n, "constructor") && n.constructor;
    return typeof t == "function" && t instanceof t && Y.call(t) == lt;
  }
  var ln = Ve ? rt(Ve) : zt;
  function ui(e) {
    return Yt(e, dn(e));
  }
  function dn(e) {
    return be(e) ? Gt(e) : jt(e);
  }
  var Fi = Zt(function(e, n, t) {
    rn(e, n, t);
  });
  function mi(e) {
    return function() {
      return e;
    };
  }
  function un(e) {
    return e;
  }
  function gi() {
    return !1;
  }
  r.exports = Fi;
})(ce, ce.exports);
var ua = ce.exports;
const w = /* @__PURE__ */ da(ua);
function Fa(r) {
  const i = window == null ? void 0 : window.matchMedia(r), [o, c] = Ai(i == null ? void 0 : i.matches);
  return Le(() => {
    const f = () => c(i.matches);
    return i.addEventListener("change", f), () => i.removeEventListener("change", f);
  }, []), o;
}
const hn = 1;
var q, V, le;
class y {
  constructor(i) {
    F(this, "breakpoints");
    F(this, "colours");
    F(this, "font");
    F(this, "typography");
    F(this, "sizing");
    F(this, "effects");
    F(this, "opacity");
    F(this, "borderRadius");
    F(this, "isDark", !1);
    F(this, "name", "base");
    F(this, "key");
    ie(this, q, 0.625);
    ie(this, V, 0.05);
    F(this, "decimalPlaces", 2);
    F(this, "unit", "rem");
    /**
     * @param {Number|String} size
     * @returns {String} css size with unit.
     */
    ie(this, le, (i = hn) => typeof i == "string" ? i : `${W(this, q) * parseFloat(i.toString())}${this.unit}`);
    /**
     * Converts a number or string into a spacing value.
     * Up to four sizes are allowed to cater for margin and padding options.
     *
     * @deprecated - use rems for spacing instead.
     * @param {...(Number|String)} inputs of sizes
     * @returns {String}
     */
    /* istanbul ignore next */
    F(this, "spacing", (...i) => (console.warn("theme.spacing() will be removed in a future version. Use rems for spacing instead."), this.toRelative(...i)));
    /**
     * Converts a number or string into a relative value.
     * Up to four sizes are allowed to cater for margin and padding options.
     *
     * @param {...(Number|String)} inputs of sizes
     * @returns {String}
     */
    F(this, "toRelative", (...i) => (i.length === 0 ? [hn] : i.slice(0, 4)).map(W(this, le)).join(" "));
    /**
     * @param {Number|String} size
     * @param {Object} [options]
     * @param {Boolean} options.appendUnits
     * @param {Number} options.decimalPlaces
     * @returns {string|number}
     */
    F(this, "formattedSize", (i, {
      appendUnits: o = !0,
      /** @deprecated The default `decimalPlaces` will change from 2 to 4 in the next major version.
      Please start specifying `decimalPlaces` explicitly to avoid breaking changes in the next major release. */
      decimalPlaces: c = this.decimalPlaces
    } = {}) => {
      const f = +parseFloat(i).toFixed(c);
      return o ? `${f}${this.unit}` : f;
    });
    /**
     * Given a size token or any size (in rems) convert to px
     * Useful for measuring in JS
     */
    F(this, "remToPx", (i) => {
      const f = Object.keys(this.sizing).includes(i.toString()) ? this.sizing[i] : i;
      return parseFloat(f) * parseFloat(getComputedStyle(document.documentElement).fontSize);
    });
    /**
     * @param {String} breakpoint
     * @param {Object} [options]
     * @param {String} options.mediaType
     * @returns {String} Media Query to a max width
     */
    F(this, "mediaQueryTo", (i, o) => {
      const c = (o == null ? void 0 : o.mediaType) || "screen", f = this.formattedSize(parseFloat(this.breakpoints[i].toString()) - W(this, V));
      return `@media ${c} and (max-width: ${f})`;
    });
    /**
     * @param {String} breakpoint
     * @param {Object} [options]
     * @param {String} options.mediaType
     * @returns {String} Media Query from a min width
     */
    F(this, "mediaQueryFrom", (i, o) => {
      const c = (o == null ? void 0 : o.mediaType) || "screen", f = this.formattedSize(this.breakpoints[i]);
      return `@media ${c} and (min-width: ${f})`;
    });
    /**
     * @param {String} startBreakpoint
     * @param {String} endBreakpoint
     * @param {Object} [options]
     * @param {String} options.mediaType
     * @returns {String} Media Query
     */
    F(this, "mediaQueryInBetween", (i = "xs", o = "xl", c = { mediaType: void 0 }) => {
      const f = (c == null ? void 0 : c.mediaType) || "screen", C = this.breakpoints[o], k = this.formattedSize(this.breakpoints[i]), A = this.formattedSize(parseFloat(C.toString()) - W(this, V));
      return `@media ${f} and (min-width: ${k}) and (max-width: ${A})`;
    });
    /**
     * @param {String} breakpointOrQuery
     * @returns {MediaQueryList | undefined}
     */
    F(this, "mediaQueryMatch", (i = "md") => {
      const c = (this.breakpoints[i] ? this.mediaQueryTo(i, {}) : i).replace("@media screen and ", "");
      return Fa(c);
    });
    // Shorthand aliases for media queries.
    F(this, "mqFrom", this.mediaQueryFrom);
    F(this, "mqTo", this.mediaQueryTo);
    F(this, "mqInBetween", this.mediaQueryInBetween);
    F(this, "mqMatch", this.mediaQueryMatch);
    /**
     * @param {String} hexColour hex colour value
     * @param {String} opacityToken design token to use
     * @returns {String} hex colour with opacity
     */
    F(this, "applyOpacity", (i, o) => {
      const c = this.opacity[o], f = Math.round(c * 255).toString(16).padStart(2, "0");
      return `${i}${f}`;
    });
    this.breakpoints = w({}, Ie, i == null ? void 0 : i.breakpoints), this.colours = w({}, i != null && i.isDark ? N : I, i == null ? void 0 : i.colours), this.font = w({}, xe, i == null ? void 0 : i.font), this.typography = w({}, Ge, i == null ? void 0 : i.typography), this.effects = w({}, He, i == null ? void 0 : i.effects), this.opacity = w({}, pe, i == null ? void 0 : i.opacity), this.borderRadius = w({}, Ne, i == null ? void 0 : i.borderRadius), this.isDark = !!(i != null && i.isDark), this.sizing = w({}, Be, i == null ? void 0 : i.sizing), i != null && i.name && (this.name = i == null ? void 0 : i.name, this.key = i == null ? void 0 : i.name.replace(/ /g, "-").toLowerCase()), i != null && i.spacing && gn(this, q, parseFloat(i == null ? void 0 : i.spacing.toString())), i != null && i.decimalPlaces && (this.decimalPlaces = i == null ? void 0 : i.decimalPlaces);
  }
}
q = new WeakMap(), V = new WeakMap(), le = new WeakMap();
const Se = {
  dark: new y({
    colours: {
      ...N,
      ...re,
      ...B
    },
    isDark: !0,
    name: "Core Dark"
  }),
  light: new y({
    colours: {
      ...I,
      ...re,
      ...p
    },
    name: "Core Light"
  })
}, we = {
  dark: new y({
    colours: {
      ...N,
      ...oe,
      ...B
    },
    isDark: !0,
    name: "IQ Dark"
  }),
  light: new y({
    colours: {
      ...I,
      ...oe,
      ...p
    },
    name: "IQ Light"
  })
}, Oe = {
  dark: new y({
    colours: {
      ...N,
      ...se,
      ...B
    },
    isDark: !0,
    name: "Video Dark"
  }),
  light: new y({
    colours: {
      ...I,
      ...se,
      ...p
    },
    name: "Video Light"
  })
}, ve = {
  dark: new y({
    colours: {
      ...N,
      ...fe,
      ...B
    },
    isDark: !0,
    name: "Tracking Dark"
  }),
  light: new y({
    colours: {
      ...I,
      ...fe,
      ...p
    },
    name: "Tracking Light"
  })
}, kn = {
  borderRadius: {
    primary: "0.125rem",
    secondary: "0.25rem",
    tertiary: "0"
  },
  font: {
    family: "Helvetica, sans serif",
    importUrl: null
  },
  opacity: {
    overlay: 0.6,
    secondary: 0.9
  }
}, L = {
  light: {
    layer0: {
      main: "#0A1F33",
      strong: "#101417",
      weak: "#13293F",
      ink: "#E6F2FF"
    },
    layer1: {
      main: "#353F4A",
      strong: "#232A31",
      weak: "#232A31",
      ink: "#E6F2FF"
    },
    layer2: {
      main: "#191F24",
      strong: "#232A31",
      weak: "#313B45",
      ink: "#E6F2FF"
    }
  },
  dark: {
    layer0: {
      main: "#353F4A",
      strong: "#3D4752",
      weak: "#394857",
      ink: "#FFFFFF"
    },
    layer1: {
      main: "#353F4A",
      strong: "#232A31",
      weak: "#232A31",
      ink: "#E6F2FF"
    },
    layer2: {
      main: "#101417",
      strong: "#232A31",
      weak: "#07090A",
      ink: "#E6F2FF"
    }
  }
}, An = {
  light: Array(5).fill(L.light.layer0, 0).fill(L.light.layer1, 1, 2).fill(L.light.layer2, 2, 3),
  dark: Array(5).fill(L.dark.layer0, 0).fill(L.dark.layer1, 1, 2).fill(L.dark.layer2, 2, 3)
}, bn = {
  light: {
    canvas: {
      primary: {
        main: "#EBEFF2",
        weak: "#F2F5F7",
        strong: "#DCE1E6",
        ink: "#13293F"
      },
      secondary: {
        main: "#F2F5F7",
        weak: "#FCFDFD",
        strong: "#EBEFF2",
        ink: "#13293F"
      },
      tertiary: {
        main: "#FFFFFF",
        weak: "#FFFFFF",
        strong: "#EDF0F2",
        ink: "#13293F"
      }
    },
    graphics: {
      primary: {
        main: "#13293F",
        strong: "#0C1926",
        weak: "#1B3A59",
        ink: "#FFFFFF"
      },
      inverse: {
        main: "#E6F2FF",
        strong: "#FFFFFF",
        weak: "#CFDAE5",
        ink: "#13293F"
      }
    },
    ink: {
      primary: {
        main: "#13293F",
        strong: "#0C1926",
        weak: "#1B3A59"
      },
      inverse: {
        main: "#E6F2FF",
        strong: "#FFFFFF",
        weak: "#CFDAE5"
      },
      highlight: {
        main: "#4DB9EB",
        strong: "#45A5D1",
        weak: "#54C9FF"
      }
    },
    messaging: {
      info: {
        strong: "#00ADFA",
        weak: "#008BC9"
      },
      success: {
        main: "#78A101",
        strong: "#8BBA01",
        weak: "#658701"
      },
      warning: {
        main: "#F2B601",
        strong: "#FFC30D",
        weak: "#D9A301"
      },
      error: {
        main: "#E81B00",
        strong: "#FF2003",
        weak: "#CF1800"
      },
      unknown: {
        main: "#4D6680",
        strong: "#5C7A99",
        weak: "#3D5166",
        ink: "#FFFFFF"
      }
    },
    navigation: {
      primary: {
        main: "#FFFFFF",
        weak: "#FFFFFF",
        strong: "#F5F9FC",
        ink: "#13293F"
      },
      secondary: {
        main: "#FFFFFF",
        weak: "#FFFFFF",
        strong: "#F5F9FC",
        ink: "#13293F"
      }
    },
    layering: An.light
  },
  dark: {
    canvas: {
      primary: {
        main: "#2C343E",
        weak: "#2A353D",
        strong: "#3E4957",
        ink: "#FFFFFF"
      },
      secondary: {
        main: "#191F24",
        weak: "#191E24",
        strong: "#2C343E",
        ink: "#FFFFFF"
      },
      tertiary: {
        main: "#101417",
        weak: "#07090A",
        strong: "#191F24",
        ink: "#FFFFFF"
      }
    },
    graphics: {
      primary: {
        main: "#E6F2FF",
        weak: "#CFDAE5",
        strong: "#FFFFFF",
        ink: "#13293F"
      },
      inverse: {
        main: "#13293F",
        weak: "#1B3A59",
        strong: "#0C1926",
        ink: "#FFFFFF"
      }
    },
    ink: {
      primary: {
        main: "#E6F2FF",
        weak: "#CFDAE5",
        strong: "#FFFFFF"
      },
      inverse: {
        main: "#13293F",
        weak: "#1B3A59",
        strong: "#0C1926"
      },
      highlight: {
        main: "#4DB9EB",
        weak: "#54C9FF",
        strong: "#45A5D1"
      }
    },
    interface: {
      main: "#1993FF",
      weak: "#157BD5",
      strong: "#3FA5FF",
      ink: "#FFFFFF"
    },
    layering: An.dark,
    messaging: {
      info: {
        main: "#009DE3",
        strong: "#009DE3",
        weak: "#008BC9"
      },
      success: {
        main: "#78A101",
        strong: "#8BBA01",
        weak: "#658701"
      },
      warning: {
        main: "#F2B601",
        strong: "#FFC30D",
        weak: "#D9A301"
      },
      error: {
        main: "#E81B00",
        strong: "#FF2003",
        weak: "#CF1800"
      },
      unknown: {
        main: "#4D6680",
        strong: "#5C7A99",
        weak: "#3D5166",
        ink: "#FFFFFF"
      }
    },
    navigation: {
      primary: {
        main: "#232A31",
        strong: "#313B45",
        weak: "#313B45",
        ink: "#E6F2FF"
      },
      secondary: { ...L.dark.layer1 }
    }
  }
}, Ee = {
  dark: new y({
    ...kn,
    colours: {
      ...bn.dark,
      ...B,
      ...De
    },
    isDark: !0,
    name: "Hudl Dark"
  }),
  light: new y({
    ...kn,
    colours: {
      ...bn.light,
      ...p,
      ...De
    },
    name: "Hudl Light"
  })
}, $e = [
  Se.light,
  Se.dark,
  we.light,
  we.dark,
  Oe.light,
  Oe.dark,
  ve.light,
  ve.dark,
  Ee.light,
  Ee.dark
], Sn = ki`
  @font-face {
    font-family: ${({ theme: r }) => r.font.family};
    font-weight: 900;
    font-style: normal;
  }

  @font-face {
    font-family: ${({ theme: r }) => r.font.family};
    font-weight: 800;
    font-style: normal;
  }

  @font-face {
    font-family: ${({ theme: r }) => r.font.family};
    font-weight: 700;
    font-style: normal;
  }

  @font-face {
    font-family: ${({ theme: r }) => r.font.family};
    font-weight: 600;
    font-style: normal;
  }

  @font-face {
    font-family: ${({ theme: r }) => r.font.family};
    font-weight: 500;
    font-style: normal;
  }

  @font-face {
    font-family: ${({ theme: r }) => r.font.family};
    font-weight: 400;
    font-style: normal;
  }

  @font-face {
    font-family: ${({ theme: r }) => r.font.family};
    font-weight: 300;
    font-style: normal;
  }

  @font-face {
    font-family: ${({ theme: r }) => r.font.family};
    font-weight: 200;
    font-style: normal;
  }

  @font-face {
    font-family: ${({ theme: r }) => r.font.family};
    font-weight: 100;
    font-style: normal;
  }
  
  html {
    font-family: ${({ theme: r }) => r.font.family};
    font-size: ${({ theme: r }) => r.font.htmlSize};
    background-color: ${({ theme: r }) => r.colours.canvas.primary.main};
  }
`, yn = {
  DARK: "dark",
  LIGHT: "light"
};
function ma({ fontUrl: r }) {
  const i = "data-kitbag-theme-font", o = `link[${i}="true"]`;
  return Le(() => {
    const c = document.head.querySelector(o);
    if (!r) {
      c && document.head.removeChild(c);
      return;
    }
    if (c) {
      if (c.getAttribute("href") !== r) {
        document.head.removeChild(c);
        const f = document.createElement("link");
        f.href = r, f.rel = "stylesheet", f.setAttribute(i, "true"), document.head.appendChild(f);
      }
    } else {
      const f = document.createElement("link");
      f.href = r, f.rel = "stylesheet", f.setAttribute(i, "true"), document.head.appendChild(f);
    }
    return () => {
      const f = document.head.querySelector(o);
      f && document.head.removeChild(f);
    };
  }, [r]), null;
}
function ze({ applyGlobalStyles: r = !0, children: i, theme: o, sectionStyle: c }) {
  var C, k;
  const f = bi(null);
  return Le(() => {
    const A = r ? document.documentElement : f.current;
    o.key && (A == null || A.setAttribute("data-theme", o == null ? void 0 : o.key), A == null || A.setAttribute("data-thememode", o != null && o.isDark ? yn.DARK : yn.LIGHT));
  }, [f.current, o == null ? void 0 : o.key, o == null ? void 0 : o.isDark]), r ? /* @__PURE__ */ yi(Tn, { theme: o, children: [
    ((C = o == null ? void 0 : o.font) == null ? void 0 : C.importUrl) && /* @__PURE__ */ x(ma, { fontUrl: (k = o == null ? void 0 : o.font) == null ? void 0 : k.importUrl }),
    /* @__PURE__ */ x(Sn, {}),
    i
  ] }) : /* @__PURE__ */ x("section", { ref: f, style: c, children: /* @__PURE__ */ x(Tn, { theme: o, children: i }) });
}
function ga() {
  const r = Cn(), [i] = r.key.split("-"), o = $e.find((c) => c.key === `${i}-dark`);
  return o || console.warn(`Unable to use DarkTheme. No Dark Theme equivelant was found for ${i}`), o || r;
}
function Ta({ children: r }) {
  const i = ga();
  return /* @__PURE__ */ x(ze, {
    theme: i,
    applyGlobalStyles: !1,
    sectionStyle: { display: "flex", height: "100%" },
    children: r
  });
}
function ha() {
  const r = Cn(), [i] = r.key.split("-"), o = $e.find((c) => c.key === `${i}-light`);
  return o || console.warn(`Unable to use LightTheme. No Light Theme equivelant was found for ${i}`), o || r;
}
function ka({ children: r }) {
  const i = ha();
  return /* @__PURE__ */ x(ze, {
    theme: i,
    applyGlobalStyles: !1,
    sectionStyle: { display: "flex", height: "100%" },
    children: r
  });
}
const _a = {
  // UI style tokens
  borderRadius: Ne,
  breakpoints: Ie,
  font: xe,
  sizing: Be,
  opacity: pe,
  effects: He,
  typography: Ge,
  // brand colours
  iqBrand: oe,
  videoBrand: se,
  coreBrand: re,
  trackingBrand: fe,
  // visualisation only colours
  visualisationsDark: B,
  visualisationsLight: p,
  // foundation only colours
  foundationsDark: N,
  foundationsLight: I,
  // Provider
  ThemeProvider: ze,
  WithDarkTheme: Ta,
  WithLightTheme: ka,
  // utils
  getThemeValueByKey: fa,
  TokensAsCSSVars: la,
  formatTokensAsCssVars: Ke,
  GlobalStyle: Sn,
  // custom themes
  themes: $e,
  coreTheme: Se,
  hudlTheme: Ee,
  iqTheme: we,
  trackingTheme: ve,
  videoTheme: Oe,
  // Theme class and constructor
  Theme: y
};
export {
  Sn as GlobalStyle,
  y as Theme,
  ze as ThemeProvider,
  la as TokensAsCSSVars,
  Ta as WithDarkTheme,
  ka as WithLightTheme,
  Ne as borderRadius,
  Ie as breakpoints,
  re as coreBrand,
  Se as coreTheme,
  _a as default,
  He as effects,
  xe as font,
  Ke as formatTokensAsCssVars,
  N as foundationsDark,
  I as foundationsLight,
  fa as getThemeValueByKey,
  De as hudlBrand,
  Ee as hudlTheme,
  oe as iqBrand,
  we as iqTheme,
  pe as opacity,
  Be as sizing,
  $e as themes,
  fe as trackingBrand,
  ve as trackingTheme,
  Ge as typography,
  se as videoBrand,
  Oe as videoTheme,
  B as visualisationsDark,
  p as visualisationsLight
};
